"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var DpModalBody_1 = __importDefault(require("./DpModalBody"));
var DpModalFooter_1 = __importDefault(require("./DpModalFooter"));
var DpModalHeader_1 = __importDefault(require("./DpModalHeader"));
var DpModal_styled_1 = require("./DpModal.styled");
var DpModal = function (props) {
    var transformModalProps = function () {
        var modalProps = __assign(__assign({}, props), { backdrop: props.backdrop || 'static' });
        if (modalProps.size === 'md') {
            delete modalProps.size;
            modalProps.dialogClassName = (0, classnames_1.default)(modalProps.dialogClassName, 'modal-md');
        }
        return modalProps;
    };
    return (0, jsx_runtime_1.jsx)(DpModal_styled_1.StyledDpModal, __assign({}, transformModalProps(), { role: "main" }));
};
exports.DpModal = DpModal;
exports.DpModal.Header = DpModalHeader_1.default;
exports.DpModal.Body = DpModalBody_1.default;
exports.DpModal.Footer = DpModalFooter_1.default;
exports.default = exports.DpModal;
